export interface CommentData {
    id: number
    authorId: number
    firstName: string
    lastName: string
    avatarUrl: string
    text: string
    date: string
    likes: number
    /** Текущий пользователь поставил лайк (my_reaction === 1). */
    likedByMe: boolean
    isUpdated: boolean
    canDelete?: boolean
    replies?: ReplyData[]
    repliesSummary?: RepliesSummaryData
    /** counters.children > числа уже загруженных дочерних узлов */
    hasMoreChildren?: boolean
}

/** Максимальная отображаемая ступень вложенности ответов от корня ветки (L1 корень блока комментария). */
export const MAX_VISIBLE_REPLY_THREAD_DEPTH = 3

export interface ReplyData {
    id: number
    commentId: number
    authorId: number
    firstName: string
    lastName: string
    avatarUrl: string
    text: string
    date: string
    likes: number
    /** Текущий пользователь поставил лайк (my_reaction === 1). */
    likedByMe: boolean
    isUpdated: boolean
    canDelete?: boolean
    /**
     * В ленте под L2: число сообщений под якорём (для счётчика «N ответов» / переход в тред).
     * Не дублирует поле счётчиков после открытия модалки.
     */
    threadChildrenCount?: number
    /** Строка «В ответ …» при наличии reply_to с API; иначе не показываем блок. */
    inReplyToLine?: string
    replyTo: {
        userId: number
        firstName: string
        lastName: string
    }
    replies?: ReplyData[]
    repliesSummary?: RepliesSummaryData
    hasMoreChildren?: boolean
}

export interface RepliesSummaryData {
    count: number
    firstReplyAuthor: {
        firstName: string
        lastName: string
        avatarUrl: string
    };
};

export interface CommentProps {
    comment: CommentData
}

export interface ReplyProps {
    reply: ReplyData
}

export interface RepliesSummaryProps {
    repliesSummary: RepliesSummaryData
}
